export const routes = {
    login: '/login',
    products: '/products',
    product_add: '/product_add',
    sales: '/sales',
    dashboard: '/dashboard',
};